import { useLocation, useNavigate } from 'react-router-dom'
import { AccountButton } from 'gunsi-auth'
import { useTallyI18n } from '../i18n/tally.js'
import { SyncStatus } from './SyncStatus.jsx'

export function TopBar() {
  const { pathname } = useLocation()
  const navigate     = useNavigate()
  const t            = useTallyI18n()

  const tabs = [
    { path: '/dashboard',    label: t.nav.overview },
    { path: '/transactions', label: t.nav.transactions },
    { path: '/stats',        label: t.nav.stats },
    { path: '/categories',   label: t.nav.categories },
    { path: '/converter',    label: t.nav.converter },
    { path: '/manage',       label: t.nav.manage },
  ]

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button
          className="topbar-title-btn"
          onClick={() => navigate('/dashboard')}
          aria-label={t.nav.overview}
        >
          <span className="topbar-title">
            Gunsi <span className="accent">Tally</span>
          </span>
        </button>
      </div>
      <nav className="topbar-nav">
        {tabs.map(tab => (
          <button
            key={tab.path}
            className={`topbar-nav-btn${pathname === tab.path || pathname.startsWith(tab.path + '/') ? ' active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className="topbar-right">
        <SyncStatus />
        <button
          className={`topbar-gear-btn${pathname === '/settings' ? ' active' : ''}`}
          onClick={() => navigate('/settings')}
          title={t.nav.settings}
          aria-label={t.nav.settings}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </button>
        <AccountButton accentColor="var(--g-accent)" />
      </div>
    </div>
  )
}
